// Small per-field provenance badge (CONTRACTS §4). Caption-sourced fields are
// the authority for what they cover, so they are marked DISTINCTLY and labelled
// "authoritative"; manual edits are also called out.

import type { FieldSource } from "../types";

const LABELS: Record<FieldSource, string> = {
  caption: "caption",
  nga: "NGA",
  met: "Met",
  wikidata: "Wikidata",
  gemini: "Gemini",
  manual: "you",
};

const TITLES: Record<FieldSource, string> = {
  caption:
    "From the printed caption — AUTHORITATIVE. The caption is definitive for the fields it states and overrides all other sources.",
  nga: "From National Gallery of Art open data.",
  met: "From the Met Museum collection API.",
  wikidata: "From Wikidata / Wikimedia Commons.",
  gemini: "Gemini's visual guess (lowest precedence; fills caption/source gaps).",
  manual: "Manually edited by you (never auto-overwritten on re-enrich).",
};

export function SourceBadge({ source }: { source: FieldSource | undefined }) {
  if (!source) return null;
  const isCaption = source === "caption";
  return (
    <span
      className={
        "source-badge source-badge--" +
        source +
        (isCaption ? " source-badge--authoritative" : "")
      }
      title={TITLES[source]}
    >
      {isCaption && <span aria-hidden="true" className="source-badge__star">★</span>}
      {LABELS[source]}
      {isCaption && <span className="source-badge__auth"> · authoritative</span>}
    </span>
  );
}
